// extracted by mini-css-extract-plugin
export default {"card":"t4-z"};